import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import DatePicker from 'src/components/ui/DatePicker';

const DATE_FORMAT = 'YYYY-MM-DD';
const DISPLAY_FORMAT = 'DD.MM.YYYY';

const DATE_FIELD_LOCALE_TEXT = {
	fieldDayPlaceholder: () => 'дд',
	fieldMonthPlaceholder: () => 'мм',
	fieldYearPlaceholder: () => 'гггг',
};

const pickerSlotProps = {
	textField: {
		fullWidth: true,
		sx: {
			'& .MuiInputBase-root': {
				height: 40,
			},
		},
	},
};

const toDayjs = (value) => {
	if (!value) return null;

	const parsed = dayjs(value);

	return parsed.isValid() ? parsed : null;
};

const toApiDate = (value) => {
	if (!value || !dayjs(value).isValid()) return '';

	return dayjs(value).format(DATE_FORMAT);
};

const parseInitialValue = (selectedValue) => {
	if (selectedValue && typeof selectedValue === 'string') {
		const splitted = selectedValue.split('~');

		return splitted.length === 2 ? splitted : [];
	}

	if (Array.isArray(selectedValue)) {
		return selectedValue;
	}

	return [];
};

const RangeDateField = ({
	value: selectedValue,
	onChange: handleSelectedValueChange,
}) => {
	const [value, setValue] = useState(() => parseInitialValue(selectedValue));

	const handleChange = (newValue, variant) => {
		const index = variant === 'first' ? 0 : 1;

		setValue((prev) => {
			const next = [...prev];
			next[index] = toApiDate(newValue);
			return next;
		});
	};

	const getValue = (variant) => {
		const index = variant === 'first' ? 0 : 1;

		return value[index];
	};

	useEffect(() => {
		handleSelectedValueChange(null, value);
	}, [handleSelectedValueChange, value]);

	const firstDate = toDayjs(getValue('first'));
	const secondDate = toDayjs(getValue('second'));

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1}
			divider={<Typography color="secondary">—</Typography>}
		>
			<Box sx={{ flex: 1 }}>
				<DatePicker
					value={firstDate}
					onChange={(date) => handleChange(date, 'first')}
					format={DISPLAY_FORMAT}
					localeText={DATE_FIELD_LOCALE_TEXT}
					maxDate={secondDate || undefined}
					sx={{ width: '100%' }}
					slotProps={pickerSlotProps}
				/>
			</Box>
			<Box sx={{ flex: 1 }}>
				<DatePicker
					value={secondDate}
					onChange={(date) => handleChange(date, 'second')}
					format={DISPLAY_FORMAT}
					localeText={DATE_FIELD_LOCALE_TEXT}
					minDate={firstDate || undefined}
					sx={{ width: '100%' }}
					slotProps={pickerSlotProps}
				/>
			</Box>
		</Stack>
	);
};

RangeDateField.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	onChange: PropTypes.func,
};

export default RangeDateField;
